import "./css/style.css"
import loaderImage from "../../../../../brand/_auth/loadingScreen/view/layout/antos/assets/loader.gif";

export default function AntosLoader({size}) {
    return (
        <div id={"antos-loader"}>
            <img alt={"loader"} src={loaderImage} className={"loader-gif"}/>
        </div>
    );
}